import { createContext, useContext } from "react";

export const CurrentUserContext = createContext();

export const useCurrentUserContext = () => useContext(CurrentUserContext);
